Vue.component("assetOverview", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition name="assetOverviewAnimation">
            <div class="assetOverview__wrapper" v-if="componentReady">
                <div class="assetOverview__search__wrapper" v-if="!isSinglePack">
                    <ul>
                        
                        <li v-for="letter in searchLetters"
                            :class="{'inactive-letter': letter.inactive, 'active-letter': selectedSort === letter.value}"
                            @click="setCurrentFilter(letter.value, letter.inactive)">
                                <span v-html="letter.value"></span>
                            </li>
                        <li :class="{'active-letter': selectedSort === null}"
                            @click="setCurrentFilter(null, false)"><span>VIS ALLE</span></li>
                    </ul>
                </div>

                <div class="assetOverview__packs__wrapper" ref="assetPacks" :style="{'overflow-y': isSinglePack ? 'auto' : 'scroll'}">
                    <div class="assetOverview__packs" :style="{width: packs[0].assets.length <= 3 && isSinglePack ? '1125px' : '875px', 'padding-top': isSinglePack ? '80px' : '60px'}">
                        <div class="assetOverview__packs__titles">
                            <h2 v-html="title"></h2>
                            <h3 v-html="subtitle"></h3>  
                        </div> 

                        <ul class="assetOverview__packs__list">
                            <li v-for="pack in filteredPacks" v-show="selectedSort === getPackFirstLetter(pack).toLowerCase() || selectedSort === null">
                                <h5 v-html="!isSinglePack ? getPackFirstLetter(pack) : ''"></h5>

                                <div class="assetOverview__packs__contentpack" v-for="singlePack in pack">
                                    <h6 v-html="singlePack.title" v-if="singlePack.title !== ''"></h6>
                                    <ul :style="{'justify-content': isSinglePack && singlePack.assets.length < 3 ? 'space-evenly' : 'space-between'}">
                                        <li v-for="asset in singlePack.assets">
                                            <h3 v-html="asset.title"></h3>
                                            <h4 v-html="asset.subtitle"></h4>

                                            <button class="downloadbutton" @click="downloadLink(asset.linkUrl)">DOWNLOAD</button>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <button class="assetOverview__close" @click="close">
                    <img src="assets/img/ui/close-white.svg">
                </button>
            </div>
        </transition>
    `,
    data() {
        return {
            componentReady: false,
            title: "",
            subtitle: "",
            packs: [],
            selectedSort: null
        }
    },
    methods: {
        getPackFirstLetter(pack) {
            return pack[0].title.charAt(0);
        },
        setCurrentFilter(letter, inactive) {
            if (inactive)
                return;

            this.selectedSort = this.selectedSort == letter ? null : letter;

            this.$nextTick(() => {
                this.$refs.assetPacks.scrollTop = 0;
            });
            console.log("sorting for: " + this.selectedSort)
        },

        sortPacks(property) {
            return function (a, b) {
                if (a[property] < b[property]) {
                    return -1;
                } else if (a[property] > b[property]) {
                    return 1;
                } else {
                    return 0;
                }
            }
        },
        downloadLink(url) {
            var win = window.open(url, '_blank');
            win.focus();
        }
    },
    computed: {
        filteredPacks() {
            let groups = {};

            //group by letter
            this.packs.forEach(function (contact) {
                let firstLetter = contact.title.charAt(0);
                if (!groups[firstLetter]) {
                    groups[firstLetter] = [];
                }
                let entry = groups[firstLetter];
                entry.firstLetter = firstLetter;

                entry.push(contact);
            });


            // prepare for sort
            let finalgroups = Object.keys(groups).map((k) => groups[k]);

            // big grouping sort by letter
            finalgroups.sort(this.sortPacks("firstLetter"));

            //small grouping sort by letter
            for (var i = 0; finalgroups.length > i; i++) {
                for (var x = 0; finalgroups[i].length > x; x++) {
                    finalgroups[i].sort(this.sortPacks("title"))
                }
            }

            return finalgroups;
        },
        searchLetters() {
            let alphabet = 'abcdefghijklmnopqrstuvwxyzæøå'.split('');

            let finalAlphabet = alphabet.map((r) => ({
                value: r,
                inactive: true
            }));


            this.filteredPacks.forEach(function (pack) {
                let letter = pack.firstLetter.toLowerCase();

                if (letter == "æ") {
                    finalAlphabet[26].inactive = false;
                } else if (letter == "ø") {
                    finalAlphabet[27].inactive = false;
                } else if (letter == "å") {
                    finalAlphabet[28].inactive = false;
                } else {
                    finalAlphabet[letter.charCodeAt(0) - 97].inactive = false;
                }
            })

            return finalAlphabet;
        },
        isSinglePack() {
            return this.packs.length === 1;
        }
    },
    mounted() {
        // handle intro animation
        this.componentReady = true;
    },
})

touchKit.ComponentManager.register("assetOverview", {
    singleton: true
});